export const SECURITY_PAYMENT = 'SECURITY_PAYMENT';
export const SET_GOAL_GRAPH = 'SET_GOAL_GRAPH';
